import React, { createContext, useState, useEffect, useCallback } from 'react';
import useGainsQCApi from '../services/useGainsQCApi';

const endpointContext = createContext();

const EndpointProvider = ({ children, env, isAuthenticated }) => {
	const [dbData, setDbData] = useState({
		smelterSitesWithCaptures: [],
		stockpilesSitesWithCaptures: [],
		availableCapsSmelters: {},
		availableCapsStockpiles: {},
		capsInUsersQueues: [],
		allCommodities: [],
		qcUsers: [],
		commentCategories: [],
		commentStatuses: [],
		lastUpdate: ''
	});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchSmelterSites = useGainsQCApi();
	
	const fetchSmelterAvailableCaps = useGainsQCApi();
	const fetchSmeltersQueueLength = useGainsQCApi();
	const fetchAllCommodities = useGainsQCApi();
	const fetchUsers = useGainsQCApi();
	const fetchGainsSites = useGainsQCApi()
	const fetchCommentStatuses = useGainsQCApi()
	const fetchCommentCategories = useGainsQCApi()

	const endpoints = [
		{ req: fetchSmelterSites, path: `/smelters/sites?hasCaptures=true` }, 
		{
			req: fetchSmelterAvailableCaps,
			path: `/smelters/available-captures?siteTypeIds=1`
		},
		{ req: fetchSmeltersQueueLength, path: `/smelters/queue_length` },
		{ req: fetchAllCommodities, path: `/smelters/commodities` },
		{ req: fetchUsers, path: `/users`, api: 'gainsAPI' },
		{ req: fetchGainsSites, path: `/v1/sites`, api: 'gainsAPI' },
		{ req: fetchCommentCategories, path: `/smelters/comments/categories` },
		{ req: fetchCommentStatuses, path: `/smelters/comments/statuses` }
	];

	const fetchData = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			await Promise.all(
				endpoints.map(({ req, path, api }) =>
					req.makeRequest(
						path,
						'GET',
						null,
						undefined,
						undefined,
						undefined,
						undefined,
						api ? api : undefined
					)
				)
			);
		} catch (error) {
			setError(error.message);
		} finally {
			setLoading(false);
		}
	}, [env]);

	useEffect(() => {
		if (!loading) {
			let timeDateNow = new Date();

			setDbData({
				smelterSitesWithCaptures: endpoints[0].req?.data?.data ?? null,
				availableCapsSmelters: endpoints[1].req?.data?.data ?? null,
				capsInUsersQueues: endpoints[2].req?.data?.data ?? null,
				allCommodities: endpoints[3].req?.data?.data ?? null,
				qcUsers: endpoints[4].req?.data ?? null,
				gainsSites: endpoints[5].req?.data ?? null,
				commentCategories: endpoints[6].req?.data ?? null,
				commentStatuses: endpoints[7].req?.data ?? null,
				lastUpdate: timeDateNow.toLocaleTimeString()
			});
		}
	}, [loading]);

	useEffect(() => {
		if (isAuthenticated) {
			fetchData();
		}
	}, [fetchData, isAuthenticated]);

	return (
		<endpointContext.Provider
			value={{ dbData, loading, error, refresh: fetchData }}
		>
			{children}
		</endpointContext.Provider>
	);
};

export { endpointContext, EndpointProvider };
